import {
  UserCompanyRole,
  Permission,
  hasPermission,
  hasAnyPermission,
  isRoleAtLeast,
} from '@monorepo/shared';

export const canAccessAdminDashboard = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.VIEW_PERFORMANCE_DASHBOARD);
};

export const canManageDocuments = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.ADD_DOCUMENT);
};

export const canDiffuseDocuments = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.DIFFUSE_DOCUMENT);
};

export const canManageUsers = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.EDIT_USER_INFO);
};

export const canManageGroups = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.CREATE_GROUP);
};

export const canInviteUsersToGroups = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.INVITE_USER_TO_GROUP);
};

export const canAccessCompanySettings = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.VIEW_COMPANY_INFO);
};

export const canAccessUserManagement = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.VIEW_USER_MANAGEMENT);
};

export const canAccessMultipleCompanies = (role: UserCompanyRole): boolean => {
  return hasPermission(role, Permission.VIEW_MY_COMPANIES);
};

export const isAdmin = (role: UserCompanyRole): boolean => {
  return isRoleAtLeast(role, UserCompanyRole.SUPER_USER);
};

export const isSuperAdmin = (role: UserCompanyRole): boolean => {
  return role === UserCompanyRole.SUPER_ADMIN;
};

export { hasPermission, hasAnyPermission, isRoleAtLeast, Permission };
